import { Form } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CheckboxInput, TextFieldInput } from '@dhl/formik'
import { AddressInput, useCreateAddressValidationSchema } from '@dhl/input-address'
import { Box, Button, Card, Grid, H6 } from '@dhl-ui/components'
import { links } from '~/AppRoutes'

export const useCreateServicepointVendorValidationSchema = () => {
  const { t } = useTranslation()
  const addressValidationSchema = useCreateAddressValidationSchema('parcel', 'NL')

  return Yup.object({
    address: addressValidationSchema,
    externalId: Yup.string().required(t('admin.servicePointVendorsPage.servicePointVendorsForm.error')),
    name: Yup.string().required(t('admin.servicePointVendorsPage.servicePointVendorsForm.error')),
  }).defined()
}

export const ServicepointVendorForm: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Card>
      <Card.Header title={t('admin.servicePointVendorsPage.servicePointVendorsForm.header')} />
      <Card.Content>
        <Box pb={2}>
          <H6>{t('admin.servicePointVendorsPage.servicePointVendorsForm.subTitle')}</H6>
        </Box>

        <Form data-testid="servicepoint-form">
          <Box>
            <Grid container spacing={2}>
              <Grid size={{ sm: 12 }}>
                <TextFieldInput
                  label={t('admin.servicePointVendorsPage.servicePointVendorsForm.externalId')}
                  name="externalId"
                  type="text"
                />
              </Grid>
              <Grid>
                <TextFieldInput
                  fullWidth
                  label={t('admin.servicePointVendorsPage.servicePointVendorsForm.name')}
                  name="name"
                  type="text"
                />
              </Grid>
              <Grid>
                <AddressInput carrier="parcel" country="NL" name="address" />
              </Grid>
              <Grid size={{ sm: 6 }}>
                <TextFieldInput
                  label={t('admin.servicePointVendorsPage.servicePointVendorsForm.country')}
                  name="country"
                  type="text"
                  disabled
                />
              </Grid>
              <Grid size={{ sm: 12 }}>
                <TextFieldInput
                  label={t('admin.servicePointVendorsPage.servicePointVendorsForm.rolcoNumber').toString()}
                  name="rolcoNumber"
                  type="text"
                />
              </Grid>
              <Grid>
                <CheckboxInput
                  name="isPopular"
                  label={t('admin.servicePointVendorsPage.servicePointVendorsForm.isPopular').toString()}
                />
              </Grid>
              <Grid size={{ sm: 12 }} display="flex" justifyContent="flex-end">
                <Button
                  color="primary"
                  variant="text"
                  size="medium"
                  onClick={() => navigate(links.servicePointVendorsLink())}
                >
                  {t('admin.servicePointVendorsPage.servicePointVendorsForm.cancelButtonTitle')}
                </Button>
                <Button color="primary" type="submit" variant="contained" size="medium">
                  {t('admin.servicePointVendorsPage.servicePointVendorsForm.save')}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Form>
      </Card.Content>
    </Card>
  )
}
